import { render, staticRenderFns } from "./valoraciones.vue?vue&type=template&id=b117b96e&scoped=true"
import script from "./valoraciones.vue?vue&type=script&lang=js"
export * from "./valoraciones.vue?vue&type=script&lang=js"
import style0 from "./valoraciones.vue?vue&type=style&index=0&id=b117b96e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b117b96e",
  null
  
)

export default component.exports